import { styles } from './template.scss';
import { ImageState } from '../../../../../../ui/gzImageRepo/types';
export const templateSearchablePolicyPanelComponent = document.createElement('template');

templateSearchablePolicyPanelComponent.innerHTML = `
  <style>${styles}</style>
  <div class="wrapper">

    <div class='loading-container'>
      <gz-progress-spinner spinnerwidth="medium"></gz-progress-spinner>
    </div>

    <gz-searchable-policy-panel-view></gz-searchable-policy-panel-view>

    <div class="policy-panel-error">
      <gz-image-repo state="${ImageState.ERROR}">
          <gz-title fontSize="14" fontWeight="400" id="error-message" />
      </gz-image-repo>
    </div>
  </div>
`;
